import OrganizationTreeGuides from './OrganizationTreeGuides'
import './OrganizationTreeName.css'
import './OrganizationTreeCard.css'

export default function OrganizationTreeCard({ level, guides, children }) {
  return (
    <div className="org-tree-card" role="listitem" style={{ '--org-indent': `calc(${level} * var(--org-tree-indent-step))`, '--org-child-indent': `calc(${level + 1} * var(--org-tree-indent-step))` }}>
      <OrganizationTreeGuides level={level} guides={guides} indentStep="var(--org-tree-indent-step)" />
      <div className="org-tree-card-content">{children}</div>
    </div>
  )
}
